import {PaginationDto} from "../../common/dto/PaginationDto";

export class VisitorBlackListSearchCondition extends PaginationDto {
    name: string = '';
    email: string = '';
    mobile: string = '';
    company: string = '';
}
